import { render } from "./AboutusNew.vue?vue&type=template&id=36a0e001&scoped=true"
import script from "./AboutusNew.vue?vue&type=script&lang=js"
export * from "./AboutusNew.vue?vue&type=script&lang=js"

import "./AboutusNew.vue?vue&type=style&index=0&id=36a0e001&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a0e001"]])

export default __exports__